import { Box, CircularProgress } from '@material-ui/core';
import React from 'react';

const Loading: React.FC = () => {
  return (
    <Box>
      Carregando
      <CircularProgress size={15} style={{ marginLeft: '16px' }} />
    </Box>
  );
};

export default Loading;
